<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nSAgLb/images/cover.jpg?1684274266330" alt="This image is the cover for the book Memories from New Hampshire's Lakes and Mountains, American Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memories from New Hampshire's Lakes and Mountains, American Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p>Since colonial times, when Yankee pioneers first planted villages and homesteads in New Hampshire s rugged hill country, the Granite State s rural settlers have cultivated a vibrant pastoral society. Bruce D. Heald offers a richly nostalgic recollection of the traditions, pastimes and storied names and locales that have helped New Hampshire s backwoodsmen carve out a unique identity. With stops to consider such classic northern New England activities as ice fishing, maple sugaring and blueberry picking, Memories from New Hampshire's Lakes and Mountains: Fence Building and Apple Cider takes the reader on a special journey through folk life during New Hampshire's olden days.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bruce D. Heald
      </h2>
      
      <p class="authorDescription body article">Dr. Bruce Heald is an adjunct professor of American military history at Plymouth State University and a fellow in the International Biographical Association. He is the recipient of the Gold Medal of Honor for literary achievement from the American Biographical Institute. Dr. Heald has written several books on the history of New Hampshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02ff28a6